module.exports = __webpack_public_path__ + "static/presidents-message-d4f83136b49b0f786d5291273f765568.jpg";